/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

import { ResumeSubSection } from '../sub-section/sub-section.model';

/**
 * Data model for the Education resume section.
 */
export class ResumeEducationSubSection extends ResumeSubSection {
  /**
   * User's school name.
   */
  public schoolName: string;

  /**
   * User's degree earned.
   */
  public degree: string;

  /**
   * Start date.
   */
  public educationStartDate: Date;

  /**
   * End date.
   */
  public educationEndDate: Date;

  /**
   * flag that indicate whether entry is open for edit/view mode.
   */
  public editMode: boolean = false;

  /**
   * Currently Working for the education section.
   */
  public current = false;

  /**
   * End date placeholder for the education section.
   */
  public endDatePlaceholder: string;

  /**
   * logo url
   */
  public logoUrl: string;

  /**
   * logo image asset
   */
  public logo;

  /**
   * Default constructor.
   *
   * @param init Optional partial object definition.
   */
  constructor(init?: Partial<ResumeEducationSubSection>) {
    super(init);
    Object.assign(this, init);
  }
}
